import { OrderDraftField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getOrderDraftFilterTable(
  sort: OrderDraftField
): OrderDraftField {
  switch (sort) {
    case OrderDraftField.UPDATED_AT:
      return OrderDraftField.UPDATED_AT;
    case OrderDraftField.SOLD_TO:
      return OrderDraftField.SOLD_TO;
    case OrderDraftField.CONTRACT_NO:
      return OrderDraftField.CONTRACT_NO;
    default:
      return undefined;
  }
}

export const getSortOrderDraftFilterTable = createGetSortQueryVariables(
  getOrderDraftFilterTable
);
